/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Data_Collected_S32_Item_1Inputs */

const es_privacy_policy_data_collected_s32_item_1 = /** @type {(inputs: Privacy_Policy_Data_Collected_S32_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direccion IP, tipo y version de navegador, sistema operativo`)
};

const en_privacy_policy_data_collected_s32_item_1 = /** @type {(inputs: Privacy_Policy_Data_Collected_S32_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IP address, browser type and version, operating system`)
};

/**
* | output |
* | --- |
* | "IP address, browser type and version, operating system" |
*
* @param {Privacy_Policy_Data_Collected_S32_Item_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_data_collected_s32_item_1 = /** @type {((inputs?: Privacy_Policy_Data_Collected_S32_Item_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Data_Collected_S32_Item_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_data_collected_s32_item_1(inputs)
	return en_privacy_policy_data_collected_s32_item_1(inputs)
});
export { privacy_policy_data_collected_s32_item_1 as "privacy_policy.data_collected.s32_item_1" }